<template>
	<div>
		<div class="btn-row">
			<ReFilterBtn v-model="bShowFilter" />
			<div class="bntGroup ml-3 showchannels">
				<base-button type="primary" simple @click="showChannels()">{{channelBtnText.text}}</base-button>
			</div>
		</div>
		<div class="col-lg-6 mt-2" v-show="bShowFilter">
			<ReFilter :masAllFilterParams="masAllFilterParams"/>
		</div>

		<div class="row">
			<div class="col posts">
				<div>
					<card class="ReChannelPost mt-2" :class="{'focus-shadow' : !isShown}">
						<div slot="header">
							<h5 @click="showPostForm()"><i class="tim-icons icon-send text-success mr-3"></i>Добавить публикацию</h5>
						</div>
						<div class="postAddForm" :class="[isShown ? 'postAddForm-hide' : 'postAddForm-show']">
							<ReChannelPostAdd></ReChannelPostAdd>
						</div>
					</card>
				</div>

				<ReChannelBig></ReChannelBig>
			</div>

			<div class="col-md col-xl-4 mt-2">
				<ReChannels :class="[channelHidden ? 'allChannels-hide' : 'allChannels-show']"></ReChannels>
			</div>
		</div>
	</div>
</template>

<script>
import ReFilterBtn from "src/our_components/FilterPrinter/ReFilterBtn.vue";
import ReChannels from "src/our_components/ReChannels.vue";
import ReFilter from "src/our_components/FilterPrinter/ReFilter.vue";
import ReChannelBig from "src/our_components/ReChannelBig.vue";
import ReChannelPostAdd from "src/our_components/ReChannelPostAdd.vue";

export default {
	name: "line-page",
	components: {
		ReFilterBtn,
		ReChannels,
		ReFilter,
		ReChannelBig,
		ReChannelPostAdd,
	},
	data() {
		return {
			bShowFilter: false,
			channelHidden: true,
			channelBtnText: {
				text: "Показать каналы"
			},
			isShown: true,
			masChannels:[],
			masAllFilterParams: this.currentFilterConfig(),

		};
	},
	methods: {
		getApiData() {
			/*
			this.$GVO.ApiCall("GET", { obj: "SOC", flt:{list:true} })
				.then(objApi => {
					if (objApi.success === true) {
						if (objApi.data.length > 0) {
							this.masChannels = objApi.data;
						}
					}
				})
				.catch(errorObjApi => console.log(errorObjApi));
			*/
		},
		showChannels() {
			this.channelHidden = !this.channelHidden;
			if (this.channelHidden) {
				this.channelBtnText.text = "Показать каналы";
			} else {
				this.channelBtnText.text = "Скрыть каналы";
			}
		},
		showPostForm() {
			this.isShown = !this.isShown;
		},
		currentFilterConfig() {
			return require("src/conf/channelsFilterConfig.js").super_config;
			return [];
    	}

	},
	mounted() {
		this.getApiData();
	}
};
</script>

<style scoped>
.bntGroup .btn {
	margin-top: 0;
}
.btn-row {
	display: flex;
	flex-direction: row;
}
.showchannels {
	display: none;
}
.focus-shadow {
	box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
	border: 1px solid rgba(7, 179, 225, 0.5);
}
.postAddForm-hide {
	display: none;
}
.postAddForm-show {
	display: block;
}
.ReChannelPost >>> .card-body {
	padding: 0 15px;
}

.ReChannelPost {
	border: 1px solid transparent;
}
.ReChannelPost:hover {
	border: 1px solid rgba(7, 179, 225, 0.5);
}
.ReChannelPost h5 {
	cursor: pointer;
}

@media (max-width: 767px) {
	.posts {
		order: 2;
	}
	.showchannels,
	.allChannels-show {
		display: block;
	}
	.allChannels-hide {
		display: none;
	}
}
</style>
